import Popover from '@mui/material/Popover';
import React__default, { useImperativeHandle, useEffect } from 'react';
import { Component, ZigDropdownContainer, NavList, ComponentSeparator, ComponentWrapper, NavLink, ChildContainer, SpaceTaker, ArrowBottomIconStyled, SubNavList } from './styles.js';
import { useTheme } from 'styled-components';

var ZigDropdown = function (_a, innerRef) {
    var _b = _a.id, id = _b === void 0 ? "" : _b, component = _a.component, options = _a.options, _c = _a.anchorOrigin, anchorOrigin = _c === void 0 ? {
        vertical: "bottom",
        horizontal: "right",
    } : _c, anchorPosition = _a.anchorPosition, _d = _a.transformOrigin, transformOrigin = _d === void 0 ? {
        vertical: "top",
        horizontal: "right",
    } : _d, disabled = _a.disabled;
    var _e = React__default.useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var _f = React__default.useState(null), childDropdownShow = _f[0], setChildDropdownShown = _f[1];
    var isOpen = !!anchorEl;
    var theme = useTheme();
    var handleToggle = function (event) {
        return !disabled ? setAnchorEl(function (v) { return (v ? null : event.currentTarget); }) : function () { };
    };
    var handleClose = function () {
        setChildDropdownShown(null);
        setAnchorEl(null);
    };
    useImperativeHandle(innerRef, function () { return ({
        closeDropDown: function () {
            handleClose();
        },
        open: isOpen,
    }); }, [anchorEl, isOpen]);
    var onClick = function (f) { return function (e) {
        e.preventDefault();
        handleClose();
        setTimeout(function () {
            if (e.button === 1) {
                window.open(e.currentTarget.href);
            }
            else {
                f();
            }
        });
    }; };
    useEffect(function () {
        window.addEventListener("scroll", handleClose);
        return function () {
            window.removeEventListener("scroll", handleClose);
        };
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Component, { role: "button", onClick: handleToggle, id: id && "".concat(id, "-container") }, component({ open: isOpen })),
        options && (React__default.createElement(Popover, { id: "popover-menu", anchorEl: anchorEl, open: isOpen, disableScrollLock: true, PaperProps: {
                sx: {
                    minWidth: "220px",
                    backgroundColor: theme.palette.neutral800,
                    whiteSpace: "nowrap",
                    color: "#fff",
                    boxShadow: "0 4px 6px -2px #00000061",
                    borderRadius: "4px 0 4px 4px",
                    border: "none",
                },
            }, onClose: handleClose, anchorPosition: anchorPosition, transformOrigin: transformOrigin, anchorOrigin: anchorOrigin },
            React__default.createElement(ZigDropdownContainer, { id: id },
                React__default.createElement(NavList, null, options.map(function (entry, i) {
                    var _a, _b;
                    if (childDropdownShow && options.indexOf(childDropdownShow) < i)
                        return null;
                    var key = (entry && "label" in entry && typeof entry.label === "string" && entry.label) ||
                        entry.id ||
                        Math.random().toString();
                    if ("separator" in entry) {
                        return (React__default.createElement(ComponentSeparator, { id: entry.id || "dropdown-element-".concat(i), separator: entry.separator, customStyle: entry.customStyle, key: key }));
                    }
                    var option = entry;
                    if (option.element)
                        return (React__default.createElement(ComponentWrapper, { id: option.id || "dropdown-element-".concat(i), customStyle: option.customStyle, key: key }, option.element));
                    if (option.href || option.onClick)
                        return (React__default.createElement(NavLink, { id: option.id, key: key, target: option === null || option === void 0 ? void 0 : option.target, active: option === null || option === void 0 ? void 0 : option.active, customStyle: option.customStyle, as: "a", href: option.href, onClick: option.onClick && onClick(option.onClick) }, option.label));
                    if (option.children)
                        return (React__default.createElement(ChildContainer, { key: key, active: childDropdownShow === option },
                            React__default.createElement(NavLink, { active: option === null || option === void 0 ? void 0 : option.active, id: option.id, customStyle: option.customStyle, notClickable: !((_a = option.children) === null || _a === void 0 ? void 0 : _a.length), onClick: function () {
                                    var _a;
                                    return ((_a = option.children) === null || _a === void 0 ? void 0 : _a.length) &&
                                        setChildDropdownShown(function (v) { return (v ? null : option); });
                                } },
                                option.label,
                                React__default.createElement(SpaceTaker, null),
                                !!((_b = option.children) === null || _b === void 0 ? void 0 : _b.length) && (React__default.createElement(ArrowBottomIconStyled, { color: theme.palette.neutral300, rotated: childDropdownShow === option, width: "10.5px" }))),
                            childDropdownShow === option && (React__default.createElement(SubNavList, null, option.children.map(function (c, index) { return (React__default.createElement(NavLink, { id: c.id, active: (c === null || c === void 0 ? void 0 : c.active) || undefined, key: "--sub-" +
                                    key +
                                    "--" +
                                    (typeof c.label === "string" ? c.label : "-child-".concat(index)), onClick: onClick(c.onClick) }, c.label)); })))));
                })))))));
};
var ZigDropdown$1 = React__default.forwardRef(ZigDropdown);

export { ZigDropdown$1 as default };
